import utils from 'utils';
import modalBlankCancel from './view/modalBlankCancel.html';
import applyReopenInvoiceTemplate from './view/SureApplyReopenInvoice.html';
import stockService from 'common/services/stockService';

class cancelInvoiceListCtrl {
  constructor(
    $scope,
    $uibModal,
    $q,
    logger,
    httpRequest,
    $state,
    getOvatAmtService,
    sweetalert,
    $timeout,
    canceledInvoiceService,
    initSortService,
    invoiceOpenService,
    exportSettingService
  ) {
    const { orgId } = $scope.userInfo.org;
    // 存储页面信息
    const userInfo = $scope.userInfo || {};
    $scope.pageState = {
      userInfo,
    };
    $scope.ukeyList = userInfo.sysUkeyList;
    $scope.dictData = {};
    const types = [
      'is_red_all',
      'cancel_type',
      'inv_type',
      'reopen_status',
      'yes_no_flag',
      'reopen_status',
      'department_no',
    ];
    httpRequest.get_dictByTypeArr(types).then((res) => {
      $scope.dictData = res.data.value;
      $scope.dictData.is_red_all = [
        {
          enumTypeCode: null,
          enumName: '蓝票',
          enumCode: '0',
        },
        {
          enumTypeCode: null,
          enumName: '红票',
          enumCode: '1',
        },
      ];
      // 没有电子发票种类
      $scope.dictData.inv_type.splice(3, 1);
    });
    //所属大区
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    // 获取主管税局省（市）
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    // 联动查询出管理城市
    $scope.linkageQuery = function (enumName) {
      let departmenNoObj = $scope.dictData.department_no.find((v) => {
        return v.enumName === enumName;
      });
      let belleRegionListObj = $scope.belleRegionList.find((v) => {
        return v.regionName === enumName;
      });
      if (departmenNoObj) {
        $scope.departmentNo = departmenNoObj.enumCode;
      }
      if (belleRegionListObj) {
        $scope.regionNo = belleRegionListObj.treeLevelCode;
      }
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    };
    //机构树的check配置信息
    $scope.config = {
      check: {
        enable: true, //显示不显示复选框
        chkboxType: { Y: '', N: '' },
        chkStyle: 'checkbox',
      },
    };
    // 获取机构
    function getUserOrgList() {
      httpRequest.get_getUserOrgList().then((res) => {
        if (res.data.success) {
          $scope.orgList = res.data.value;
          // 机构勾选变化
          $scope.orgIdListArr = [];
          // 展开节点及全选
          angular.forEach($scope.orgList, function (item, index) {
            item.open = true;
            if (orgId == item.orgId) {
              item.checked = true;
              $scope.orgIdListArr.push(item.orgId);
              // 默认当前操作机构
              $scope.selectedOrgList = [item];
            }
          });
          $scope.param.param.orgIdList = $scope.orgIdListArr;
          // 默认全部数据
          //   $scope.selectedOrgList = $scope.orgList;
          // 返回机构名称
          $scope.fliterOrgName = function (id) {
            if (id === null) {
              return id;
            }
            if (res.data.value === null) {
              return id;
            }
            const fliterUkeyNameArr = res.data.value.filter(
              (item) => item.orgId === id
            );
            if (fliterUkeyNameArr.length > 0) {
              return fliterUkeyNameArr[0].orgName;
            }
            return id;
          };
        }
        get_getUserCustomized();
      });
    }
    getUserOrgList();
    // 所选择的机构名称
    $scope.handleOrgChange = function (orgData) {
      //重置
      $scope.orgIdListArr = [];
      if (orgData.length > 0) {
        angular.forEach(orgData, function (item, index) {
          $scope.orgIdListArr.push(item.orgId);
        });
        $scope.param.param.orgIdList = $scope.orgIdListArr;
      } else {
        $scope.orgIdListArr = [];
        $scope.param.param.orgIdList = $scope.orgIdListArr;
      }
    };
    // 是否全选机构
    $scope.orgIsCheckAll = (orgList) => {
      let orgListArr = [];
      angular.forEach(orgList, (item, index) => {
        orgListArr.push(item.orgId);
      });
      $scope.param.param.orgIdList = orgListArr;
    };
    $scope.exportCollapsed = false;
    $scope.exportConfig = {
      version: 1.24,
      mainInfo: [
        {
          // 0
          label: '单据编号',
          selected: true,
          defaultWord: true,
        },
        {
          label: '开票流水号',
          selected: false,
          defaultWord: false,
        },
        {
          // 2
          label: '发票种类',
          selected: true,
          defaultWord: true,
        },
        {
          // 2
          label: '发票性质',
          selected: true,
          defaultWord: true,
        },
        {
          // 3
          label: '发票代码',
          selected: true,
          defaultWord: true,
        },
        {
          // 4
          label: '发票号码',
          selected: true,
          defaultWord: true,
        },
        {
          // 5
          label: '开票日期',
          selected: false,
          defaultWord: false,
        },
        {
          // 6
          label: '购方名称',
          selected: true,
          defaultWord: true,
        },
        {
          // 7
          label: '购方信用代码',
          selected: true,
          defaultWord: true,
        },
        {
          label: '购方地址电话',
          selected: false,
          defaultWord: false,
        },
        {
          label: '购方开户行及账号',
          selected: false,
          defaultWord: false,
        },
        {
          label: '销方开户行及账号',
          selected: false,
          defaultWord: false,
        },
        {
          // 10
          label: '合计金额',
          selected: true,
          defaultWord: true,
        },
        {
          // 10
          label: '合计税额',
          selected: true,
          defaultWord: true,
        },
        {
          // 10
          label: '价税合计',
          selected: true,
          defaultWord: true,
        },
        {
          // 15
          label: '含税折扣金额',
          selected: false,
          defaultWord: false,
        },
        {
          label: '备注',
          selected: false,
          defaultWord: false,
        },
        {
          // 16
          label: '作废类型',
          selected: false,
          defaultWord: false,
        },
        {
          label: '作废日期',
          selected: true,
          defaultWord: true,
        },
        {
          label: '重开状态',
          selected: false,
          defaultWord: false,
        },
        {
          label: '申请重开日期',
          selected: false,
          defaultWord: false,
        },
        {
          label: '开票点',
          selected: false,
          defaultWord: false,
        },
        {
          label: '作废原因',
          selected: false,
          defaultWord: false,
        },
        {
          label: '成品油',
          selected: false,
          defaultWord: false,
        },
        {
          label: '扩展1',
          selected: false,
          default: false,
        },
        {
          label: '扩展2',
          selected: false,
          default: false,
        },
        {
          label: '扩展3',
          selected: false,
          default: false,
        },
      ],
    };
    $scope.exportSetting = function exportSetting() {
      exportSettingService(148, $scope.exportConfig);
    };
    $scope.exportInvoic = function () {
      const params = $.extend({}, $scope.param.param);
      const idArr = [];
      $scope.selectedList.forEach((item) => {
        idArr.push(item.invoiceId);
      });
      params.idList = idArr.join(',');
      let url = `${host.etcloudOvat}cancelAndReopenInvoice/exportCancelInvoiceExcel`;
      url = `${url}?accessToken=${localStorage.getItem('id_token')}`;
      for (let i in $scope.param.orderMap) {
        params.sortField = i + ':' + $scope.param.orderMap[i];
      }
      console.log(params);
      utils.post_downLoad(params, url);
    };
    $scope.batchDropdownConfig = {
      btnText: '批量操作',
      options: [
        {
          text: '批量申请重开',
          hasPermit: 'cancelInvoice_applyrepeat',
          handler() {
            $scope.applyReopenInvoiceBatch();
          },
        },
        {
          text: '批量重开',
          hasPermit: 'cancelInvoice_repeat',
          handler() {
            $scope.reopenInvoiceListBatch();
          },
        },
        {
          text: '空白作废',
          hasPermit: 'cancelInvoive_nullCancel',
          handler() {
            $scope.openModalBlankCancel();
          },
        },
      ],
    };
    // 初始化
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        cancelDateMin: '',
        cancelDateMax: '',
        custCodeName: '',
        isRed: '',
        cancelType: '',
        invType: '',
        invoiceCode: '',
        invoiceNumber: '',
        reopenDateMin: '',
        reopenDateMax: '',
        ukeyCode: '',
        reopenStatus: '',
        billCode: '',
        billBatchNo: '',
        isOil: '',
      },
      orderMap: {},
    };
    $scope.reset = function () {
      $scope.param.param = {
        cancelDateMin: '',
        cancelDateMax: '',
        custCodeName: '',
        isRed: '',
        cancelType: '',
        invType: '',
        invoiceCode: '',
        invoiceNumber: '',
        reopenDateMin: '',
        reopenDateMax: '',
        ukeyCode: '',
        reopenStatus: '',
        billCode: '',
        billBatchNo: '',
        isOil: '',
        orgIdList: $scope.orgIdListArr,
      };
      $scope.belleRegionCityList = [];
      getUserOrgList();
      $scope.$broadcast('selectedOrgList', $scope.selectedOrgList);
    };
    // $scope.reset()
    $scope.resData = [];
    // tab变化
    $scope.isCollapsed = false; // 批量下拉

    // 表头排序
    $scope.orderMap = initSortService('cancelParam');
    $scope.selectedHandle = function () {
      $scope.param.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.param.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      sessionStorage.setItem('cancelParam', JSON.stringify($scope.param));
      queryCancelInvoice();
    };
    $scope.currentOvatAmt = {};
    $scope.$watch('selectedList.length', () => {
      if (!$scope.selectedList.length) {
        $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal;
        $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum;
        $scope.totalAmt = $scope.currentOvatAmt.totalAmt;
        $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt;
        return;
      }
      const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService(
        $scope.selectedList
      );
      $scope.adValoremTotal = adValoremTotal;
      $scope.invoiceNum = $scope.selectedList.length;
      $scope.totalAmt = totalAmt;
      $scope.totalTaxamt = totalTaxamt;
    });

    function getData() {
      httpRequest.post_getReInvoiceStatics($scope.param.param).then((res) => {
        $scope.adValoremTotal =
          res.data.value.adValoremTotal.toFixed(2) || '0.00';
        $scope.invoiceNum = res.data.value.invoiceNum || 0;
        $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00';
        $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00';
        $scope.currentOvatAmt = {
          adValoremTotal: $scope.adValoremTotal,
          invoiceNum: $scope.invoiceNum,
          totalAmt: $scope.totalAmt,
          totalTaxamt: $scope.totalTaxamt,
        };
      });
    }
    $scope.customizedConfig = {
      version: 1.49,
      queryConfig: [
        {
          label: '作废日期',
          selected: true,
          default: true,
        },
        {
          label: '购方名称/信用代码',
          selected: true,
          default: true,
        },
        {
          label: '发票性质',
          selected: false,
          default: false,
        },
        {
          label: '作废类型',
          selected: false,
          default: false,
        },
        {
          label: '发票种类',
          selected: true,
          default: true,
        },
        {
          label: '发票代码',
          selected: false,
          default: false,
        },
        {
          label: '申请重开日期',
          selected: false,
          default: false,
        },
        {
          label: '开票点',
          selected: false,
          default: false,
        },
        {
          label: '重开状态',
          selected: false,
          default: false,
        },
        {
          label: '单据编号',
          selected: false,
          default: false,
        },
        {
          label: '发票号码',
          selected: false,
          default: false,
        },
        {
          label: '成品油',
          selected: false,
          default: false,
        },
        {
          label: '机构名称',
          default: false,
          selected: false,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
      ],
      table: [
        {
          label: '发票种类',
          selected: true,
          default: true,
        },
        {
          label: '发票代码',
          selected: true,
          default: true,
        },
        {
          label: '发票性质',
          selected: true,
          default: true,
        },
        {
          label: '发票号码',
          selected: true,
          default: true,
        },
        {
          label: '开票日期',
          selected: true,
          default: true,
        },
        {
          label: '购方名称/信用代码',
          selected: true,
          default: true,
        },
        {
          label: '购方地址电话',
          selected: false,
          default: false,
        },
        {
          label: '购方开户行及账号',
          selected: false,
          default: false,
        },
        {
          label: '作废类型',
          selected: true,
          default: true,
        },
        {
          label: '关联销售单',
          selected: false,
          default: false,
        },
        {
          label: '合计金额/税额',
          selected: true,
          default: true,
        },
        {
          label: '价税合计',
          selected: false,
          default: false,
        },
        {
          label: '含税折扣金额',
          selected: false,
          default: false,
        },
        {
          label: '备注',
          selected: false,
          default: false,
        },
        {
          label: '作废日期',
          selected: false,
          default: false,
        },
        {
          label: '重开状态',
          selected: false,
          default: false,
        },
        {
          label: '重开失败原因',
          selected: false,
          default: false,
        },
        {
          label: '申请重开日期',
          selected: false,
          default: false,
        },
        {
          label: '开票点',
          selected: false,
          default: false,
        },
        {
          label: '单据编号',
          selected: true,
          default: true,
        },
        {
          label: '作废原因',
          selected: false,
          default: false,
        },
        {
          label: '开票流水号',
          selected: false,
          default: false,
        },
        {
          label: '成品油',
          selected: false,
          default: false,
        },
        {
          label: '销方开户行及账号',
          selected: false,
          default: false,
        },
        {
          label: '机构名称',
          default: false,
          selected: false,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
      ],
    };

    // 返回开票点名称
    $scope.filterUkeyName = function (id) {
      if (id === null) {
        return id;
      }
      if ($scope.pageState.userInfo.sysUkeyList === null) {
        return id;
      }
      const fliterUkeyNameArr = $scope.pageState.userInfo.sysUkeyList.filter(
        (item) => item.ukeyId === id
      );
      if (fliterUkeyNameArr.length > 0) {
        return fliterUkeyNameArr[0].ukeyName;
      }
      return id;
    };

    // 查询列表
    const queryCancelInvoice = function () {
      $scope.param = sessionStorage.cancelParam
        ? JSON.parse(sessionStorage.cancelParam)
        : $scope.param;
      httpRequest.post_getInvalidReopenInvoiceList($scope.param).then((res) => {
        $scope.resData = res.data.value.list;
        $scope.param.pageNum = res.data.value.pageNum;
        $scope.selectedList = [];
        // 获取后台分页数据 回写分页组件
        $scope.totalItems = res.data.value.total; //
        $scope.currentPage = ++res.data.value.prePage;
        $scope.maxSize = res.data.value.pageSize;
      });
      getData();
    };

    $scope.tableDropdownConfig = [
      {
        label: '详情',
        handler(item) {
          const { invoiceId } = item;
          let url;
          if (item.invType == 12) {
            url = $state.href(
              'outputManage.billManage.cancelInvoice.vehiceDetail',
              {
                invoiceId,
              },
              {
                reload: true,
              }
            );
          } else if (item.invType == 41) {
            url = $state.href(
              'outputManage.billManage.cancelInvoice.rollDetail',
              {
                invoiceId,
              },
              {
                reload: true,
              }
            );
          } else {
            url = $state.href(
              'outputManage.billManage.cancelInvoice.detail',
              {
                invoiceId,
              },
              {
                reload: true,
              }
            );
          }
          window.open(url, '_blank');
        },
        showWhile(item, hasPermit) {
          return hasPermit('cancelInvoice_view') && item.cancelType === '1';
        },
      },
      {
        label: '申请重开',
        handler(item) {
          const invoiceList = [];
          invoiceList.push(item);
          $scope.modalSureApplyReopenInvoice(invoiceList, '申请重开');
        },
        showWhile(item, hasPermit) {
          const statusValid =
            item.cancelType === '1' &&
            (item.reopenStatus === null ||
              item.reopenStatus === '' ||
              item.reopenStatus === '4');
          return hasPermit('cancelInvoice_applyrepeat') && statusValid;
        },
      },
      {
        label: '重开',
        handler(item) {
          let urlStr = '';
          switch (item.invType.toString()) {
            case '0': //专用发票
            case '2': //普通发票
              urlStr = 'outputManage.billManage.cancelInvoice.cancelNomal';
              break;
            case '41': //卷式发票
              urlStr = 'outputManage.billManage.cancelInvoice.cancelRoll';
              break;
            case '12': //机动车发票
              urlStr = 'outputManage.billManage.cancelInvoice.cancelVehicle';
              break;
          }
          httpRequest.post_submitReopenOvatInvoice(item.invoiceId).then(() => {
            urlStr &&
              $state.go(urlStr, {
                invType: item.invType,
                canceledInvoiceId: item.invoiceId,
              });
          });
        },
        showWhile(item, hasPermit) {
          const statusValid =
            item.cancelType === '1' &&
            (item.reopenStatus === null ||
              item.reopenStatus == '' ||
              item.reopenStatus === '2' ||
              item.reopenStatus === '5');
          return hasPermit('cancelInvoice_repeat') && statusValid;
        },
      },
      {
        label: '回退',
        handler(item) {
          sweetalert
            .confirm('确认回退', '确定要回退后则撤回重开申请？')
            .then(() => {
              httpRequest
                .post_backReopenInvoice(item.invoiceId, '回退成功')
                .then((res) => {
                  if (res.data.success) {
                    queryCancelInvoice();
                  }
                });
            });
        },
        showWhile(item, hasPermit) {
          const statusValid =
            item.cancelType === '1' &&
            (item.reopenStatus === '2' ||
              item.reopenStatus === '3' ||
              item.reopenStatus === '5');
          return hasPermit('cancelInvoice_backRepeatApply') && statusValid;
        },
      },
    ];
    // 搜索
    $scope.searchList = function () {
      sessionStorage.setItem('cancelParam', JSON.stringify($scope.param));
      queryCancelInvoice();
    };

    // 开票信息
    // 选中开票行
    $scope.invoice = {};
    $scope.selectedList = [];
    if (sessionStorage.cancelParam) {
      let cancelParam = JSON.parse(sessionStorage.cancelParam);
      cancelParam.orderMap = {};
      if ($scope.orderMap.sortKey)
        cancelParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal;
      sessionStorage.setItem('cancelParam', JSON.stringify(cancelParam));
    } else {
      $scope.param.orderMap = {};
      if ($scope.orderMap.sortKey)
        $scope.param.orderMap[$scope.orderMap.sortKey] =
          $scope.orderMap.sortVal;
      sessionStorage.setItem('cancelParam', JSON.stringify($scope.param));
    }
    // 优化 先执行获取机构接口在调用
    function get_getUserCustomized() {
      httpRequest.get_getUserCustomized(10).then((res) => {
        if (res.data.value) {
          let orderMap = JSON.parse(res.data.value).orderMap;
          if (orderMap) {
            $scope.orderMap = orderMap;
          }
        }
        if ($scope.orderMap.sortKey) {
          $scope.param.orderMap[$scope.orderMap.sortKey] =
            $scope.orderMap.sortVal;
        }
        sessionStorage.setItem('cancelParam', JSON.stringify($scope.param));
        queryCancelInvoice();
      });
    }

    // 分页
    $scope.totalItems = 0; // 组件初始化设置总页数
    $scope.currentPage = 1; // 设置显示第一页
    $scope.maxSize = 10; // 每一叶显示记录数
    $scope.pageChanged = function () {
      // 点击页码发起查询
      sessionStorage.setItem(
        'cancelParam',
        JSON.stringify({
          orderMap: $scope.param.orderMap,
          pageNum: $scope.param.pageNum,
          pageSize: $scope.param.pageSize,
          param: sessionStorage.cancelParam
            ? JSON.parse(sessionStorage.cancelParam).param
            : {
                cancelDateMin: '',
                cancelDateMax: '',
                custCodeName: '',
                isRed: '',
                cancelType: '',
                invType: '',
                invoiceCode: '',
                invoiceNumber: '',
                reopenDateMin: '',
                reopenDateMax: '',
                ukeyCode: '',
                reopenStatus: '',
                billCode: '',
                billBatchNo: '',
              },
        })
      );
      queryCancelInvoice();
    };
    // 状态按钮滑过
    $scope.dropdown_rowhover_state = function (row, flag) {
      row.dropdowstatenhover = flag;
    };
    // ---------------------1.申请重开-------------------
    $scope.applyReopenInvoiceBatch = function () {
      if ($scope.selectedList.length == 0) {
        logger.logError('还未选择数据');
        return;
      }
      $scope.modalSureApplyReopenInvoice($scope.selectedList, '批量申请重开'); // 批量
    };

    $scope.applyReopenInvoiceList = function (invoiceList) {
      // 批量
      const invoice = invoiceList[0];
      httpRequest.post_applyReopenInvoice(invoice.invoiceId).then(
        (res) => {
          logger.logSuccess(`申请重开成功[${invoice.invoiceNumber}]`);
          if (invoiceList.length > 1) {
            $scope.applyReopenInvoiceList(invoiceList.slice(1));
          } else {
            $timeout(() => {
              queryCancelInvoice(); // 刷新页面
            }, 1000);
          }
        },
        (err) => {
          // 错误不阻塞
          logger.logError(`申请重开失败[${invoice.invoiceNumber}]${err}`);
          if (invoiceList.length > 1) {
            $scope.applyReopenInvoiceList(invoiceList.slice(1));
          } else {
            queryCancelInvoice(); // 刷新页面
          }
        }
      );
    };

    // 申请重开确认
    $scope.modalSureApplyReopenInvoice = function (invoiceList, title) {
      // ③　④　校验通过后申请重开/批量申请重开时，出现确认提示，提示当前申请重开的发票份数、发票种类、发票代码及号
      const prams = {
        invoiceList,
        modalTitle: title,
        dictData: $scope.dictData,
      };
      const modalInstance = $uibModal.open({
        template: applyReopenInvoiceTemplate,
        controller: 'modalSureCtrl',
        backdrop: 'static',
        openedClass:
          'mod-modal-haslist mod-modal mod-modal-lg mod-modal-batchred',
        resolve: {
          items1() {
            return prams;
          },
        },
      });
      modalInstance.result.then(
        (data) => {
          $scope.applyReopenInvoiceList(invoiceList);
        },
        () => {
          console.log(`Modal dismissed at: ${new Date()}`);
        }
      );
    };

    // --------------2.批量重开-----------------
    function getChangeObj(changeInv, datalist) {
      // 返回要切换的obj
      let param = {};
      // 10位发票 2联5联公用
      let invAarry = datalist.filter(
        (item) =>
          item.invoiceType == '2' &&
          item.categoryCode.length == 10 &&
          item.categoryCode[8] == changeInv
      ); // 过滤出纸质票
      // 12位 2联
      if (changeInv == '2') {
        const invAarry2 = datalist.filter(
          (item) =>
            item.invoiceType == '2' &&
            item.categoryCode.length == 12 &&
            item.categoryCode[11] == '4'
        ); // 过滤出纸质票
        invAarry = invAarry.concat(invAarry2);
      }
      if (changeInv == '5') {
        const invAarry3 = datalist.filter(
          (item) =>
            item.invoiceType == '2' &&
            item.categoryCode.length == 12 &&
            item.categoryCode[11] == '5'
        ); // 过滤出纸质票
        invAarry = invAarry.concat(invAarry3);
      }
      // 12位 5联
      if (changeInv == '2' || changeInv == '5') {
        // 切换为2联或者5联开票
        if (invAarry.length > 0) {
          // 金税盘存在联次changeInv的发票卷
          let num = -1;
          for (let i = 0; i < invAarry.length; i++) {
            if (invAarry[i].collectCount > 0) {
              num = i;
              break;
            }
          }
          if (num >= 0) {
            param = {
              invType: '2',
              invCode: invAarry[num].categoryCode,
              startNumber: invAarry[num].startNumber,
            };
          }
        }
      }
      return param;
    }

    function cbChangeUnionTypeOpen(data) {
      if (data != null) {
        if (!Object.prototype.hasOwnProperty.call(data, 'value')) {
          logger.logError(data.retmsg);
          utils.loaded();
          return;
        }
        const SIDParam = $.parseJSON(data.value);
        // console.log(SIDParam)
        if (SIDParam.InfoTypeCode[8] != $scope.selectedInvoiceNum) {
          // 当前代码段和选择代码段不一致 切换号码段并开票
          canceledInvoiceService.queryInvoiceStock().then((res) => {
            // 金税盘所有库存
            let param = getChangeObj($scope.selectedInvoiceNum, res); // 获取下一张票
            if (JSON.stringify(param) !== '{}') {
              // 有票切换票卷并开票
              stockService.changeInvoiceUnionType(param).then(() => {
                $scope.reopenInvoiceList($scope.inv2ReopenList); // 直接开票
              });
            } else {
              //
              // let inv5Aarry = res.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == "5"))
              // let inv2Aarry = res.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == "2"))
              const inv2Aarry10 = res.filter(
                (item) =>
                  item.invoiceType == '2' &&
                  item.categoryCode.length == 10 &&
                  item.categoryCode[7] == '6' &&
                  item.categoryCode[8] == '2'
              );
              const inv2Aarry12 = res.filter(
                (item) =>
                  item.invoiceType == '2' &&
                  item.categoryCode.length == 12 &&
                  item.categoryCode[10] == '0' &&
                  item.categoryCode[11] == '4'
              );
              const inv2Aarry = [].concat(inv2Aarry10).concat(inv2Aarry12);

              const inv5Aarry10 = res.filter(
                (item) =>
                  item.invoiceType == '2' &&
                  item.categoryCode.length == 10 &&
                  item.categoryCode[7] == '6' &&
                  item.categoryCode[8] == '5'
              ); // 过滤出纸质票
              const inv5Aarry12 = res.filter(
                (item) =>
                  item.invoiceType == '2' &&
                  item.categoryCode.length == 12 &&
                  item.categoryCode[10] == '0' &&
                  item.categoryCode[11] == '5'
              ); // 过滤出纸质票
              const inv5Aarry = [].concat(inv5Aarry10).concat(inv5Aarry12);

              if ($scope.selectedInvoiceNum == '2' && inv2Aarry.length == 0) {
                utils.loaded();
                logger.logError('发票库存不足');
              }
              if ($scope.selectedInvoiceNum == '5' && inv5Aarry.length == 0) {
                utils.loaded();
                // 5联票用完切换
                sweetalert.swal(
                  {
                    title: '操作提醒',
                    text: '当前开票点/金税盘不存在5联式的空白发票，是否继续开具2联式的发票？',
                    showCancelButton: true,
                    confirmButtonColor: '#0096e7',
                    confirmButtonText: '开票',
                    cancelButtonText: '取消',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                  },
                  (isConfirm) => {
                    if (isConfirm) {
                      utils.loading('正在重开，请稍候');
                      param = getChangeObj('2', res); // 切换2联发票开票
                      if (JSON.stringify(param) !== '{}') {
                        stockService.changeInvoiceUnionType(param).then(() => {
                          $scope.reopenInvoiceList($scope.inv2ReopenList); // 直接开票
                        });
                      } else {
                        logger.logError('发票库存不足');
                      }
                    }
                  }
                );
              }
            }
          });
        } else {
          $scope.reopenInvoiceList($scope.inv2ReopenList); // 直接开票
        }
      } else {
        utils.loaded();
        logger.logError(
          '读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!'
        );
      }
    }

    function openIvoiceCofirm(confirmMsg) {
      // openType 开票类型 批量或者单张
      $uibModal
        .open({
          templateUrl: 'paperInvoiceNum2.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            'items1',
            function ctrl(scope, uibModalInstance, items1) {
              scope.ivoiceNum = '2'; // 默认2联式发票
              scope.confirmMsg = items1;
              scope.cancel = function cancel() {
                uibModalInstance.close();
              };
              scope.ok = function ok() {
                uibModalInstance.close(scope.ivoiceNum);
              };
            },
          ],
          resolve: {
            items1() {
              return confirmMsg;
            },
          },
          openedClass: 'mod-modal mod-modal-md',
          backdrop: 'static',
        })
        .result.then((result) => {
          if (result) {
            utils.loading('正在重开，请稍候');
            $scope.selectedInvoiceNum = result; // 选中结果
            window.top.TaxCore.tax.invInfo(
              0,
              cbChangeUnionTypeOpen,
              null,
              null,
              0
            );
          }
        });
    }

    function checkdiffInvType(invoiceList, openType) {
      let hasInv2 = false; // 存在普票
      let hasdiffInvType = false;
      let confirmMsg =
        '当前为批量开票操作，所勾选的待开发票将开具同种发票联式的发票，请选择需要开具的发票联式：';
      if (openType == 'one') {
        confirmMsg =
          '本开票点同时存在5联式和2联式普通发票，请选择需要开具的发票联式：';
      }
      const firstInvoice = invoiceList[0];
      for (let i = 0; i < invoiceList.length; i += 1) {
        if (invoiceList[i].invType == '2') {
          hasInv2 = true;
        }
        if (invoiceList[i].invType !== firstInvoice.invType) {
          hasdiffInvType = true;
        }
      }
      if (hasInv2) {
        httpRequest.get_getTaxDisk(invoiceList[0].ukeyId).then((res) => {
          const soap =
            (localStorage.soap && JSON.parse(localStorage.soap)) || {};
          if (res.data.value.differentInvoice === 1 && soap.status == 3) {
            // 普票存在不同联次发票
            if (hasdiffInvType) {
              logger.logError(
                '本开票点同时存在2联式和5联式普通发票，请将不同票种分开开具！'
              );
              return;
            }
            // 切换票卷 然后开票
            openIvoiceCofirm(confirmMsg); // 确认后开票
          } else {
            $scope.reopenInvoiceList(invoiceList); // 直接开票
          }
        });
      } else {
        $scope.reopenInvoiceList(invoiceList); // 不存在普通票 直接开票
      }
    }

    $scope.reopenInvoiceListBatch = function () {
      // 批量
      if ($scope.selectedList.length === 0) {
        logger.logError('还未选择数据');
        return;
      }
      const canNotReopenList = $scope.selectedList.filter(
        (x) =>
          x.reopenStatus != '2' &&
          x.reopenStatus != '5' &&
          x.reopenStatus != null &&
          x.reopenStatus != ''
      );
      if (canNotReopenList.length) {
        const dicItem = $scope.dictData.reopen_status.filter(
          (x) => x.enumCode == canNotReopenList[0].reopenStatus
        );
        const errorMsg = `存在${dicItem[0].enumName}发票，请重新选择`;
        logger.logError(errorMsg);
      } else if (invoiceOpenService.chechManageTypeDiff($scope.selectedList)) {
        logger.logError('您选择的发票开票点不是同一个类型的，请重新选择');
      } else {
        $scope.modalSureReopenOvatInvoice($scope.selectedList, 'batch');
      }
    };
    $scope.invTypeMap = {
      0: '专用发票',
      2: '普通发票',
      41: '卷式发票',
      51: '电子发票',
      12: '机动车发票',
    };
    $scope.reopenInvoiceList = function reopenInvoiceList(invoiceList) {
      // 批量重开
      if (invoiceList[0].invType !== '2') {
        utils.loading('正在重开，请稍候');
      } else {
        httpRequest.get_getTaxDisk(invoiceList[0].ukeyId).then((res) => {
          if (res.data.value.differentInvoice !== 1) {
            // 普票不存在不同联次发票
            utils.loading('正在重开，请稍候');
          }
        });
      }
      canceledInvoiceService
        .batchReopen(invoiceList)
        .then(
          null,
          (err) => {
            logger.logError(err);
          },
          (notify) => {
            const { invoice, type, result } = notify;
            switch (type) {
              case 'success':
                logger.logSuccess(`发票[${invoice.invoiceNumber}]，重开成功`);
                break;
              case 'error':
                logger.logError(`发票[${invoice.invoiceNumber}]，重开失败`);
                break;
              case 'nokey':
                if (result) {
                  logger.logSuccess(`重开成功，共计${result}张发票`);
                } else {
                  logger.logError('重开失败');
                }
                break;
              default:
                break;
            }
          }
        )
        .finally(() => {
          queryCancelInvoice();
          utils.loaded();
        });
    };
    $scope.modalSureReopenOvatInvoice = function (invoiceList, openType) {
      // ③　④　校验通过后申请重开/批量申请重开时，出现确认提示，提示当前申请重开的发票份数、发票种类、发票代码及号
      const prams = {
        invoiceList,
        modalTitle: openType == 'one' ? '发票重开' : '批量重开',
        dictData: $scope.dictData,
      };
      const modalInstance = $uibModal.open({
        template: applyReopenInvoiceTemplate,
        controller: 'modalSureCtrl',
        backdrop: 'static',
        openedClass:
          'mod-modal-haslist mod-modal mod-modal-lg mod-modal-batchred',
        resolve: {
          items1() {
            return prams;
          },
        },
      });
      modalInstance.result.then(
        () => {
          if (invoiceOpenService.checkIsA9(invoiceList[0].ukeyId)) {
            utils.loading('正在重开，请稍候');
            reOpenBatch(invoiceList)
              .then((res) => {
                if (!res) return;
                if (res.length == 1) {
                  logger.logSuccess(`重开成功[${res[0].invoiceNumber}]`);
                } else if (!res.length) {
                  logger.logError('重开失败');
                } else {
                  logger.logSuccess(`操作完成，共重开成功${res.length}张发票`);
                }
              })
              .finally(() => {
                queryCancelInvoice();
                utils.loaded();
              });
          } else {
            checkdiffInvType(invoiceList, openType);
          }
          // $scope.reopenInvoiceList(invoiceList, invoiceList.length)
          $scope.inv2ReopenList = invoiceList;
        },
        () => {}
      );
    };

    function reOpenBatch(list) {
      const defered = $q.defer();
      const resArr = [];

      function open(invList) {
        if (invList.length === 0) {
          defered.resolve(resArr);
          return;
        }
        const invoice = invList.shift();
        httpRequest
          .post_a9ReopenInvoice({
            reopenInvoiceId: invoice.invoiceId,
          })
          .then(
            (res) => {
              if (res.data.value.code == 0) {
                defered.notify(`发票[${invoice.invoiceNumber}]，重开成功`);
                resArr.push(invoice);
                open(invList);
              } else {
                defered.reject(res.data.value.msg);
              }
            },
            () => {
              defered.reject();
            }
          );
      }
      open(list);
      return defered.promise;
    }
    // -------------------------3.回退    出现确认提示。确定要回退后则撤回重开申请。-------------------
    $scope.backReopenInvoice = function (invoice) {
      // 批量
      layer.confirm(
        '确定要回退后则撤回重开申请？',
        {
          title: '确认回退',
          icon: 3,
          btn: ['取消', '确认'], // 可以无限个按钮
        },
        (index) => {
          layer.close(index);
        },
        (index) => {
          layer.close(index);
          httpRequest
            .post_backReopenInvoice(invoice.invoiceId, '回退成功')
            .then((res) => {
              if (res.data.success) {
                queryCancelInvoice();
              }
            });
        }
      );
    };

    // -------------------------4.空白作废----------------

    // 批量开具空白作废
    $scope.openModalBlankCancel = function openModalBlankCancel() {
      $uibModal
        .open({
          template: modalBlankCancel,
          controller: 'modalBlankCancelCtrl',
          backdrop: 'static',
          openedClass: 'mod-modal mod-modal-lg',
        })
        .result.then(
          (item) => {
            // 首先插入作废申请记录
            const applyBlankCancelInvoiceParam = {
              ...item,
              invoiceNumberBegin: item.invoiceNumber,
              currentNum: 0,
            };
            if (applyBlankCancelInvoiceParam.ukey.manageType == 2) {
              //服务器空白作废
              utils.loading('正在进行空白作废');
              httpRequest
                .post_blankCancelInv(applyBlankCancelInvoiceParam)
                .then((res) => {
                  if (res.data.value) {
                    logger.logSuccess(`成功作废${res.data.value.length}张发票`);
                    utils.loaded();
                    queryCancelInvoice();
                  }
                });
            } else {
              httpRequest
                .post_applyBlankCancelInvoice(applyBlankCancelInvoiceParam)
                .then((res) => {
                  // 拼装组成空白作废的列表
                  $scope.blankCancelBatch(applyBlankCancelInvoiceParam);
                });
            }
          },
          () => {}
        );
    };

    $scope.blankCancelBatch = function (blankCancelParam) {
      // 批量
      blankCancelParam.currentNum++;
      blankCancelParam.success = blankCancelParam.success || 0;
      utils.loading(`空白作废第${blankCancelParam.currentNum}张发票准备中....`);
      canceledInvoiceService.blankCancel(blankCancelParam).then(
        () => {
          blankCancelParam.success += 1;
          if (blankCancelParam.blanksReq > blankCancelParam.currentNum) {
            $scope.blankCancelBatch(blankCancelParam);
          } else {
            logger.logSuccess(
              `操作完成，成功作废${blankCancelParam.success}张发票`
            );
            utils.loaded();
            queryCancelInvoice();
          }
        },
        (err) => {
          logger.logError(
            `空白作废第张${blankCancelParam.currentNum}张发票失败:${err}`
          );
          if (blankCancelParam.blanksReq > blankCancelParam.currentNum) {
            $scope.blankCancelBatch(blankCancelParam);
          } else {
            utils.loaded();
            queryCancelInvoice();
          }
        }
      );
    };

    $scope.blankCancelPromise = function (blankCancelParam) {
      const deferred = $q.defer();
      const obj = {
        sellerBankAccountNr: null,
        invoiceType: blankCancelParam.invType,
        customerName: null,
        customerTaxNr: null,
        customerAddressTel: null,
        memo: null,
        payee: null,
        checker: null,
        issuer: null,
        sellerAddressTel: null,
        listed: false,
        documentNr: null,
        invoiceItems: [],
        customerBankAccountNr: null,
        CheckEWM: 2,
      };
      window.top.TaxCore.tax.inv(
        blankCancelParam.invType,
        obj,
        (data) => {
          const SIDParam = $.parseJSON(data.value);
          if (SIDParam.retcode == '4011') {
            blankCancelParam.invoiceNumber = SIDParam.InfoNumber;
            blankCancelParam.invoiceCode = SIDParam.InfoTypeCode;
            blankCancelParam.invType = blankCancelParam.invType;
            httpRequest.post_blankCancelInvoice(blankCancelParam).then(
              (res) => {
                deferred.resolve(SIDParam);
              },
              (error) => {
                deferred.reject(error);
              }
            );
          } else {
            deferred.reject(SIDParam.retmsg);
          }
        },
        '',
        '',
        0
      );
      return deferred.promise;
    };
    // 查看关联销售单
    $scope.relatedBill = function (item) {
      if (item.billCount === 0) {
        return;
      }
      if (item.waitId === undefined) {
        return;
      }
      $state.go('outputManage.billManage.cancelInvoice.relatedBill', {
        waitId: item.waitId,
      });
    };
  }
}
cancelInvoiceListCtrl.$inject = [
  '$scope',
  '$uibModal',
  '$q',
  'logger',
  'httpRequest',
  '$state',
  'getOvatAmtService',
  'sweetalert',
  '$timeout',
  'canceledInvoiceService',
  'initSortService',
  'invoiceOpenService',
  'exportSettingService',
];
export default cancelInvoiceListCtrl;



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/cancelInvoiceListCtrl.js